/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import moment from 'moment';
import { Typography } from '@material-ui/core';

import CustomToolbar from '../../../../AppSrc/components/common/CustomToolbar/CustomToolbar';
import globals from '../../../globals/communityGlobals';
import _ from '../../../utils/lodash';
import { formatNhs } from '../../../utils/helpers';

const locale = globals.getAreas(['patients', 'error', 'userActions']);
const mapPropName = (columnName, isEntityToDto = false) => {
  const entityNames = ['Forename', 'Surname', 'NhsNumber', 'DateOfBirth', 'DateCreated', 'DateModified', 'DateOfDeath'];
  const dtoNames = ['forename', 'surname', 'nhsNumber', 'dateOfBirth', 'dateCreated', 'dateModified', 'dateOfDeath'];

  if (isEntityToDto) {
    const index = _.indexOf(entityNames, columnName);
    return dtoNames[index];
  }

  const index = _.indexOf(dtoNames, columnName);
  return entityNames[index];
};

const setSortDirection = (columnDtoName, options) => {
  const entityName = mapPropName(columnDtoName, false);

  return entityName === options.sortColumn ? options.sortDirection : 'none';
};

export const tableSettings = options => ({
  name: <Typography variant="h3">{locale.getMsg('searchResults')}</Typography>,
  columns: [
    {
      name: 'id',
      label: 'Id',
      options: {
        display: 'excluded',
      },
    },
    {
      name: 'forename',
      label: locale.getMsg('forename'),
      options: {
        sortOrder: {
          name: 'forename',
          direction: setSortDirection('forename', options),
        },
      },
    },
    {
      name: 'surname',
      label: locale.getMsg('surname'),
      options: {
        sortOrder: {
          name: 'surname',
          direction: setSortDirection('surname', options),
        },
      },
    },
    {
      name: 'nhsNumber',
      label: locale.getMsg('nhsNumber'),
      options: {
        sortOrder: {
          name: 'nhsNumber',
          direction: setSortDirection('nhsNumber', options),
        },
        customBodyRender: value => (value ? formatNhs(value) : '-'),
      },
    },
    {
      name: 'dateOfBirth',
      label: locale.getMsg('dateOfBirth'),
      options: {
        sortOrder: {
          name: 'dateOfBirth',
          direction: setSortDirection('dateOfBirth', options),
        },
        empty: true,
        customBodyRender: value => (value ? moment(value).format(globals.dateFormats.short) : '-'),
      },
    },
    ...(options.eventHandlers.isSettingPatientsAsInactiveEnabled()
      ? [
          {
            name: 'status',
            label: locale.getMsg('status'),
            options: {
              sort: false,
            },
          },
        ]
      : []),
    {
      name: 'postCode',
      label: locale.getMsg('postcode'),
      options: {
        sort: false,
      },
    },
    {
      name: 'dateCreated',
      label: locale.getMsg('dateCreated'),
      options: {
        sortOrder: {
          name: 'dateCreated',
          direction: setSortDirection('dateCreated', options),
        },
        empty: true,
        customBodyRender: value => (value ? moment(value).format(globals.dateFormats.short) : '-'),
      },
    },
    {
      name: 'dateModified',
      label: locale.getMsg('dateModified'),
      options: {
        sortOrder: {
          name: 'dateModified',
          direction: setSortDirection('dateModified', options),
        },
        empty: true,
        customBodyRender: value => (value ? moment(value).format(globals.dateFormats.short) : '-'),
      },
    },
    {
      name: 'dateOfDeath',
      label: 'DateOfDeath',
      options: {
        display: 'excluded',
      },
    },
  ],

  options: {
    filterType: 'dropdown',
    responsive: 'standard',
    selectableRows: 'none',
    rowsPerPageOptions: [5, 15, 30, 50, 100],
    rowsPerPage: options.pageSize,
    print: true,
    search: false,
    filter: false,
    serverSide: true,
    count: options.count,
    page: options.page,
    setRowProps: rowData => {
      if (rowData[options.eventHandlers.isSettingPatientsAsInactiveEnabled() ? 9 : 8] !== null) {
        return {
          style: { backgroundColor: 'rgba(0, 0, 0, 0.13)' },
        };
      }
      return {};
    },
    onRowClick: rowData => options.eventHandlers.go(`/Patients/${rowData[0]}`),
    customToolbar: () => (
      <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isTableDataLoading} />
    ),
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
        case 'changeRowsPerPage':
          options.eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
          break;
        case 'sort':
          let sortColumn = '';
          let sortDirection = '';

          if (tableState.activeColumn > -1) {
            sortColumn = mapPropName(tableState.sortOrder.name);
            sortDirection = tableState.sortOrder.direction;
            options.eventHandlers.updateTableSort(sortColumn, sortDirection);
          }
          break;
      }
    },
  },
});
